// extracted by mini-css-extract-plugin
export default {"dropdown":"LocationSelection_dropdown__suJD7"};